import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-add",
  "use": "file-add-usage",
  "viewBox": "0 0 22 28",
  "content": "<symbol viewBox=\"0 0 22 28\" xmlns=\"http://www.w3.org/2000/svg\" id=\"file-add\">\n    <path d=\"M21.47 6H17V.64L21.47 6zM22 8v19a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14v7a1 1 0 001 1h6zm-7 6a1 1 0 00-1-1h-2v-2a1 1 0 00-2 0v2H8a1 1 0 000 2h2v2a1 1 0 002 0v-2h2a1 1 0 001-1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol